// CSS Modules - component class name prefix: ZoomableMapBox__
<template>
  <div :class="[$style.container, 'columns']">
    <div
      :class="[$style.mapBox, 'column', 'is-half-tablet', 'is-half-desktop']"
    >
      <SimpleMap
        v-if="config.hasMap"
        :geolocation="config.geolocation"
        :mapZoom="config.mapZoom"
        :markerColour="config.markerColour"
      />
      <img
        v-if="config.hasMap === false"
        v-bind:src="config.img.src"
        v-bind:alt="config.img.alt"
      />
    </div>
    <div
      :class="[
        $style.descriptionBox,
        'column',
        'is-half-tablet',
        'is-half-desktop'
      ]"
    >
      <h3 v-if="config.title" v-html="config.title"></h3>
      <div v-html="config.text" :class="$style.text"></div>
      <Button
        v-if="config.link"
        colour="orange"
        v-bind:text="config.link.label"
        v-bind:href="config.link.path"
        isLink
      />
    </div>
  </div>
</template>

<script>
import Button from "../Button/Button.vue";
import SimpleMap from "../SimpleMap/SimpleMap.vue";

export default {
  name: "ZoomableMapBox",
  props: {
    config: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    Button,
    SimpleMap
  }
};
</script>

<style module lang="scss">
@import "./ZoomableMapBox.scss";
</style>
